<template>
  <el-dialog
    :visible.sync="visible"
    :close-on-click-modal="false"
    :show-close="false"
    title="Disclosure"
    width="40%"
  >
    <span style="font-size: 15px">I have fully read and will abide the Non-disclosure agreement between TUV and VSU</span>
    <br><br><br>
    <el-checkbox v-model="checked" size="lg" @change="updateDiclosure(true)"> I will abide with the agreement</el-checkbox>
    <br><br>
    <el-checkbox v-model="disagree" size="lg" @change="updateDiclosure(false)"> I have not read the agreement</el-checkbox>
    <span slot="footer" class="dialog-footer">
      <el-button v-show="checked" type="primary" @click="Accept">Confirm</el-button>
    </span>
    <span slot="footer" class="dialog-footer">
      <el-button v-show="disagree" type="danger" @click="out()">Log out</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { UserPolicy } from '../../api/user_policy'
import { Notification } from 'element-ui'

export default {
  name: 'UserPolicy',
  data() {
    return {
      checked: false,
      visible: true,
      disagree: false
    }
  },
  created() {
    if (this.$store.getters.user_policy) {
      this.$router.push({ path: '/' })
    }
  },
  methods: {
    Accept() {
      if (this.checked) {
        UserPolicy({ user_id: this.$store.getters.user.currentUser.id }, 'post').then(res => {
          if (res.data.message === 'success') {
            Notification.success({
              title: 'Success',
              message: 'Thank you for Accepting the Policy',
              duration: 4 * 1000
            })
            this.$router.push({ path: '/' })
          }
        }).catch()
      }
    },
    out() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload()
      })
    },
    updateDiclosure(item) {
      if (item) {
        this.disagree = false
      } else {
        this.checked = false
      }
    }
  }
}
</script>

<style scoped>

</style>
